import { render } from "./BaseDataCaptureSection.vue?vue&type=template&id=26b65d11&scoped=true&ts=true"
import script from "./BaseDataCaptureSection.vue?vue&type=script&lang=ts"
export * from "./BaseDataCaptureSection.vue?vue&type=script&lang=ts"

import "./BaseDataCaptureSection.vue?vue&type=style&index=0&id=26b65d11&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\e394cd1ec4c7054f\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b65d11"]])

export default __exports__